import React from 'react'
import Clients from './Clients'

import brand_01 from "../images/brand/brand01.png";
import brand_02 from "../images/brand/brand02.png";
import brand_03 from "../images/brand/brand03.png";
import brand_04 from "../images/brand/brand04.png";
import brand_05 from "../images/brand/brand05.png";
import brand_06 from "../images/brand/brand06.png";
import brand_07 from "../images/brand/brand07.png";
import brand_08 from "../images/brand/brand08.png";
import brand_09 from "../images/brand/brand09.png";
import brand_10 from "../images/brand/brand10.png";
const clientsData = [
    { image: brand_01 },
    { image: brand_02 },
    { image: brand_03 },
    { image: brand_04 },
    { image: brand_05 },
    { image: brand_06 },
    { image: brand_07 },
    { image: brand_08 },
    { image: brand_09 },
    { image: brand_10 },
  ];
export default function Client() {
    
  return (
    <div>
      <section className="section03">
            <div className="container-fluid">
            <div className="col-md-11 mx-auto">
                <div className="section-heading">
                <h2 className="heading">Clients Using Our Platform</h2>
                <p className="f-24">A large number of brands have gained customer loyalty</p>
                </div>
                <Clients client={clientsData} />
            </div>
            </div>
        </section>
    </div>
  )
}
